// New version src/Common/constants/common.constants.ts commonConstants
// Old version src/CaseDotStar.ServicePackages.Frontend.Common/scripts/common/infinite_scroll_module.js

export const commonConstants = {
	downloadFilesAPIUrl: 'api/download',
	uploadFilesAPIUrl: 'api/upload',
	USER_AVATAR_SIZE: {
		standart: 96,
		profile: 208, // TODO: @backend return error Access with size ≠ 208,
	},
	animationDuration: 200,
	defaultPageSize: 20,
	defaultNumberDigitsAfterDecimal: 2,
	defaultNumberDecimalSeparator: ',',
	defaultNumberGroupSeparator: ' ',
	dataValidation: {
		url: /^(https?:\/\/)?([\da-zа-яё\.-]+)\.([a-zа-яё\.]{2,6})([\/\w \.-]*)*\/?$/,
		imageFormats: '.png, .jpg, .jpeg, .gif, .bmp, .jpe',
		inn: /^[\d-\s]+$/,
		intNum: /^[0-9]+$/,
		cardExpire: /^(0[1-9]|1[0-2])\/\d{2}$/,
		cardExpireMonth: /^(0[1-9]|1[0-2])$/,
		cardExpireYear: /^(\d{2}|\d{4})$/,
		cardNumber: /^\d+$/,
		digits: /^\d+$/,
		email: /^[^ @]+@[^ @]/,
	},
	throttle_milleseconds: 200,
	fileUploadMaxSize: 100 * 1024 * 1024, // 100 MB
	adaptiveScreenWidth: 900,
};
